import { useEffect, useState } from 'react';

export default function HeroHeader() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const closeMenu = () => setMenuOpen(false);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md shadow-md shadow-black/5 border-b border-background-200/50'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-10 py-4 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
            <i className="ri-leaf-line text-white text-lg" />
          </div>
          <span className="font-heading font-semibold text-foreground-950 text-lg tracking-wide">
            Puro Earth
          </span>
        </div>

        {/* Desktop nav */}
        <nav className="hidden md:flex items-center gap-6">
          <a
            href="#calculator"
            className="text-sm text-foreground-600 hover:text-primary-600 transition-colors duration-200 whitespace-nowrap"
          >
            计算器
          </a>
          <a
            href="#methodology"
            className="text-sm text-foreground-600 hover:text-primary-600 transition-colors duration-200 whitespace-nowrap"
          >
            方法学
          </a>
          <a
            href="#about"
            className="text-sm text-foreground-600 hover:text-primary-600 transition-colors duration-200 whitespace-nowrap"
          >
            关于
          </a>
        </nav>

        {/* Mobile hamburger */}
        <button
          onClick={() => setMenuOpen((prev) => !prev)}
          className="md:hidden w-10 h-10 flex items-center justify-center rounded-lg border border-background-200/70 bg-background-50/80 text-foreground-700 cursor-pointer"
          aria-label={menuOpen ? '关闭菜单' : '打开菜单'}
          aria-expanded={menuOpen}
        >
          <i className={`text-lg ${menuOpen ? 'ri-close-line' : 'ri-menu-line'}`} />
        </button>
      </div>

      {/* Mobile menu panel */}
      {menuOpen && (
        <nav className="md:hidden bg-background-50/95 backdrop-blur-md border-t border-background-200/50 px-4 py-3 flex flex-col gap-1">
          <a
            href="#calculator"
            onClick={closeMenu}
            className="px-3 py-2.5 rounded-lg text-sm font-medium text-foreground-800 hover:bg-background-100 transition-colors"
          >
            计算器
          </a>
          <a
            href="#methodology"
            onClick={closeMenu}
            className="px-3 py-2.5 rounded-lg text-sm font-medium text-foreground-800 hover:bg-background-100 transition-colors"
          >
            方法学
          </a>
          <a
            href="#about"
            onClick={closeMenu}
            className="px-3 py-2.5 rounded-lg text-sm font-medium text-foreground-800 hover:bg-background-100 transition-colors"
          >
            关于
          </a>
        </nav>
      )}
    </header>
  );
}